import React, { Fragment, useState, useEffect } from "react";
import {
  Grid,
  Box,
  Typography,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  tableCellClasses,
  Paper,
  CircularProgress,
  InputAdornment,
  //   IconButton,
  //   Dialog,
  // DialogActions,
  //   DialogContent,
  //   DialogTitle,
  //   Checkbox,
  //   Button,
} from "@mui/material";
import {
  //  CheckIcon, 
  FontFamily,
  // PendingIcon, 
  SearchIcon
} from "assets";
import Colors from "assets/Style/Colors";
// import { PrimaryButton } from "components/Buttons";
// import SelectField from "components/Select";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import styled from "@emotion/styled";
import { makeStyles } from "@mui/styles";
// import {
//   Visibility as VisibilityIcon, Close as CloseIcon
// } from "@mui/icons-material";
// import DropdownMenu from "components/DropDown";
import Pagination from "components/Pagination";
import { ErrorToaster } from "components/Toaster";
import InputField from "components/Input";
import SupplierServices from "services/Supplier";
import { Debounce } from "utils";
import moment from "moment";
import DropdownMenu from "components/DropDown";
import { FiDownload } from "react-icons/fi";

// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";

// *For Table Style
const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    textAlign: "center",
    whiteSpace: "nowrap",
    background: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    textWrap: "nowrap",
    padding: "5px !important",

    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

const useStyles = makeStyles({
  loaderWrap: {
    display: "flex",
    height: 100,
    "& svg": {
      width: "40px !important",
      height: "40px !important",
    },
  },
});

function SupplierAllInvoices() {

  const mockSupplierData = [
    {
      id: 1,
      supplierCode: "SUP123",
      supplierName: "Supplier A",
      creditLimit: 50000,
      balanceDue: 12000,
      overdue: 3000,
      status: "Active",
      invoices: 10,
    },
    {
      id: 2,
      supplierCode: "SUP124",
      supplierName: "Supplier B",
      creditLimit: 70000,
      balanceDue: 25000,
      overdue: 5000,
      status: "In Active",
      invoices: 15,
    }
  ];
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm();
  const [loader, setLoader] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState([])
  const [supplierData, setSupplierData] = useState([])
  console.log(supplierData, 'supplierData')
  const [openPopup, setOpenPopup] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null);
  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [filters, setFilters] = useState({});


  const { id } = useParams();
  const handleMenuToggle = (menuId, isOpen) => {
    setActiveMenu(isOpen ? menuId : null);
  };
  const navigate = useNavigate();

  const tableHead = [
    "Supplier Code",
    "Supplier Name",
    "Credit Limit (AED)",
    "Balance Due (AED)",
    "Overdue (AED)",
    "Status",
    "Invoices",
    "Action",
  ];

  const handleOpenPopup = () => {
    setOpenPopup(true);
  };

  const handleClosePopup = () => {
    setOpenPopup(false);
  };


  const getSupplierData = async (page, limit, filter) => {
    setLoader(true);

    try {
      const Page = page ? page : currentPage
      const Limit = limit ? limit : pageLimit
      const Filter = { ...filters, ...filter }
      setCurrentPage(Page)
      setPageLimit(Limit)
      setFilters(Filter)
      let params = {
        page: Page,
        limit: Limit,
        supplier_id: id,
      }
      params = { ...params, ...Filter }

      const data = await SupplierServices.getSupplier(params);
      const rows = data?.data?.suppliers?.rows ?? [];
      const serverCount = data?.data?.suppliers?.count;
      setSupplierData(rows);
      setTotalCount(serverCount > 0 ? serverCount : rows.length);

    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };

  const handleFilter = (data) => {
    Debounce(() => getSupplierData(1, '', data));
  }

  useEffect(() => {
    getSupplierData();
  }, [])
  const downloadAllAttachments = async (filePath) => {
    if (!filePath) {
      ErrorToaster("No attachments available.");
      return;
    }

    const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${filePath.trim()}`;
    const fileExtension = filePath.split(".").pop();

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", `attachment.${fileExtension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("Download failed", error);
      ErrorToaster("Failed to download attachment.");
    }
  };
  return (
    <Box sx={{ m: 4, mb: 8 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 4,
          mt: 4,
        }}
      >
        <Typography
          sx={{
            color: "#094526",
            fontFamily: 'Helvetica',
            fontSize: "32px",
            fontStyle: "Bold",
            fontWeight: 700,
          }}
        >
          Supplier All Invoices
        </Typography>

      </Box>

      {/* Form Section */}
      <Box
      // sx={{
      //   boxShadow: "0px 4px 4px 0px #00000040",
      //   p: 3,
      //   borderRadius: "12px",
      // }}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} sm={3}>
            <InputField
              size={"small"}
              inputStyle={{ backgroundColor: "#f5f5f5" }}
              label={"Search"}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              placeholder={"Search"}
              register={register('search', {
                onChange: (e) => handleFilter({ search: e.target.value })
              })}

            />
          </Grid>


        </Grid>
      </Box>

      {/* ========== Table ========== */}
      <TableContainer
        component={Paper}
        sx={{
          boxShadow: "0px 8px 18px 0px #9B9B9B1A",
          borderRadius: 2,
          maxHeight: "calc(100vh - 330px)",
          mt: 5,
        }}
        className="table-box"
      >
        <Table stickyHeader sx={{ minWidth: 500 }}>
          <TableHead>
            <TableRow>

              <Cell>Invoice no.</Cell>
              <Cell>Invoice on</Cell>
              <Cell>Amount (AED)</Cell>
              <Cell>Attachment</Cell>
              <Cell>Action</Cell>

            </TableRow>
          </TableHead>
          <TableBody>
            {!loader ? (
              supplierData?.length > 0 ? (
                <Fragment>
                  {supplierData.map((item, index) => {
                    // const isSelected = selectedRows?.some(
                    //   (selected) => selected?.id === item?.id
                    // );

                    return (
                      <Row
                        key={index}
                        sx={{ bgcolor: index % 2 !== 0 && "#EEFBEE" }}
                      >
                        <Cell className="pdf-table">
                          {item?.id ?? "-"}
                        </Cell>
                        <Cell className="pdf-table">
                          {item.created_at ? moment(item.created_at).format("DD-MM-YYYY") : "-"}
                        </Cell>
                        <Cell className="pdf-table">
                          {item.amount ?? "-"}
                        </Cell>
                        <Cell className="pdf-table">
                          {(() => {
                            const attachments = item.supplier_documents
                              ?.filter(doc => doc.invoice_attachment)
                              ?.map(doc => doc.invoice_attachment) || [];

                            return attachments.length > 0 ? (
                              <div
                                style={{ cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "4px" }}
                                onClick={() => attachments.forEach(attachment => downloadAllAttachments(attachment))}
                              >
                                <FiDownload color={Colors.primary} />
                                {attachments.length}
                              </div>
                            ) : (
                              <FiDownload color="gray" />
                            );
                          })()}
                        </Cell>
                        {/* <Cell className="pdf-table">
                          {(() => {
                            const attachments = item.supplier_documents
                              ?.filter(doc => doc.invoice_attachment)
                              ?.map(doc => doc.invoice_attachment) || [];

                            return attachments.length > 0 ? (
                              <Box sx={{ display: "flex", flexDirection: "row", gap: "8px", justifyContent: "center", flexWrap: "wrap" }}>
                                {attachments.map((attachment, i) => (
                                  <Box
                                    key={i}
                                    onClick={() => downloadAllAttachments(attachment)}
                                    sx={{ cursor: "pointer", display: "flex", alignItems: "center", flexDirection: "column" }}
                                    title={`Invoice ${i + 1}`}
                                  >
                                    <FiDownload style={{ color: Colors.primary, fontSize: "24px" }} />
                                    
                                  </Box>
                                ))}
                              </Box>
                            ) : (
                              <Box sx={{ display: "flex", justifyContent: "center" }}>
                                <FiDownload style={{ color: "grey", fontSize: "24px" }} />
                              </Box>
                            );
                          })()}
                        </Cell> */}
                        <Cell className="pdf-table">
                          {
                            <DropdownMenu
                              item={item}
                              // permissions={permissions}
                              navigate={navigate}
                              isOpen={activeMenu === item?.id}
                              onToggle={(isOpen) =>
                                handleMenuToggle(item?.id, isOpen)
                              }
                              id={item?.id}
                              suplierListingView={() => {
                                window.open(
                                  `/supplier-detail-view/${item?.id}`,
                                );
                              }}

                            />
                          }
                        </Cell>

                      </Row>
                    );
                  })}
                </Fragment>
              ) : (
                <Row>
                  <Cell colSpan={11} align="center" sx={{ fontWeight: 600 }}>
                    No Data Found
                  </Cell>
                </Row>
              )
            ) : (
              <TableRow>
                <TableCell colSpan={11} align="center" sx={{ border: 0, py: 4 }}>
                  <CircularProgress size={40} sx={{ color: Colors.primary }} />
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      {supplierData?.length > 0 && (
        <Pagination
          currentPage={currentPage}
          pageSize={pageLimit}
          onPageSizeChange={(size) => getSupplierData(1, parseInt(size.target.value))}
          tableCount={supplierData?.length}
          totalCount={totalCount}
          onPageChange={(page) => getSupplierData(page, "")}
        />
      )}
    </Box>
  );
}

export default SupplierAllInvoices;
